import React, { useEffect, useRef } from "react";
import { createRoot } from "react-dom/client";

function App() {
  const bgRef = useRef(null);
  const lastMoveRef = useRef(Date.now());
  const animRef = useRef(null);

  const posRef = useRef({ x: 50, y: 50 });
  const targetRef = useRef({ x: 50, y: 50 });
  const driftingRef = useRef(false);

  useEffect(() => {
    const el = bgRef.current;

    const setGradient = (x, y) => {
      el.style.background = `radial-gradient(circle at ${x}% ${y}%, #000428, #004e92)`;
    };

    const handleMove = (clientX, clientY) => {
      const { width, height, left, top } = el.getBoundingClientRect();
      const x = ((clientX - left) / width) * 100;
      const y = ((clientY - top) / height) * 100;

      targetRef.current = { x, y };
      lastMoveRef.current = Date.now();
      driftingRef.current = false;
    };

    const handleMouseMove = (e) => handleMove(e.clientX, e.clientY);
    const handleTouchMove = (e) => {
      const touch = e.touches[0];
      handleMove(touch.clientX, touch.clientY);
    };

    const pickRandomTarget = () => {
      targetRef.current = {
        x: Math.random() * 100,
        y: Math.random() * 100,
      };
    };

    const animate = () => {
      const now = Date.now();
      const idleTime = now - lastMoveRef.current;

      if (idleTime > 2000 || /Mobi|Android/i.test(navigator.userAgent)) {
        if (!driftingRef.current) {
          driftingRef.current = true;
          pickRandomTarget();
        }
        
        const { x, y } = posRef.current;
        const { x: tx, y: ty } = targetRef.current;
        if (Math.abs(x - tx) < 1 && Math.abs(y - ty) < 1) {
          pickRandomTarget();
        }
      }

      const speed = 0.01;
      const { x, y } = posRef.current;
      const { x: tx, y: ty } = targetRef.current;
      const newX = x + (tx - x) * speed;
      const newY = y + (ty - y) * speed;

      posRef.current = { x: newX, y: newY };
      setGradient(newX, newY);

      animRef.current = requestAnimationFrame(animate);
    };

    el.addEventListener("mousemove", handleMouseMove);
    el.addEventListener("touchmove", handleTouchMove);
    animRef.current = requestAnimationFrame(animate);

    return () => {
      el.removeEventListener("mousemove", handleMouseMove);
      el.removeEventListener("touchmove", handleTouchMove);
      cancelAnimationFrame(animRef.current);
    };
  }, []);

  return (
      <div
          ref={bgRef}
          className="flex items-center justify-center min-h-screen transition-colors duration-300"
      >
        <div className="italic font-serif text-start max-w-3xl px-6">
          <blockquote className="text-xl font-medium text-white leading-snug md:leading-tight">
          "The&nbsp;Latin word <em>poema</em> means 'poem.' It&nbsp;is&nbsp;derived from the&nbsp;Greek <em>&#960;&#959;&#943;&#951;&#956;&#945;</em> (<em>poi&#x113;ma</em>), which means 'that which is made or created.' This reflects the artistic act of composing poetry, emphasizing the creation process. In English, the term <em>poem</em> has retained a similar meaning, referring to a literary work that expresses emotions or ideas through verse."
        </blockquote>
        <footer className="mt-6 text-lg text-white">—&nbsp;<em>Unknown</em></footer>
      </div>
    </div>
    );
}

createRoot(document.getElementById("root")).render(<App />);
